import { Skeleton } from "@/components/ui/skeleton";

const OverviewRowSkeleton = () => (
  <div className="flex items-center justify-between rounded-md border border-border/60 bg-card/95 p-3">
    <div className="flex items-center gap-3">
      <Skeleton className="h-9 w-9 rounded-md" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-56" />
        <Skeleton className="h-3 w-72" />
      </div>
    </div>
    <Skeleton className="h-6 w-32 rounded-full" />
  </div>
);

export default OverviewRowSkeleton;
